import { Completed, Draft, Expired, Pending, Submitted, Unlocked } from '../../../shared/Assets/sessionStatuses';
import { findEventIconColor } from '../Helpers/functions';

import { EventDataProperties } from '../../../redux/API/ClientAPIHelpers/calendarProperties';
import { SoapNotesStatuses } from '../../../redux/API/ClientAPIHelpers/dataCollectionProperties';

const SessionStatusIcon = ({ event }: { event: EventDataProperties }) => {
	const { isCompleted, reportId, reportStatus, sessionType } = event;
	const { type } = sessionType;
	const color = findEventIconColor(type);
	const isSessionCompletedWithoutNote = isCompleted && !reportId;
	const isDraft = reportId && SoapNotesStatuses.draft === reportStatus?.status;
	const isSubmitted = reportId && SoapNotesStatuses.submitted === reportStatus?.status;
	const isUnlocked = reportId && SoapNotesStatuses.unlocked === reportStatus?.status;
	const isPendingBT = reportId && SoapNotesStatuses.pendingBT === reportStatus?.status;
	const isExpired =
		reportId &&
		(SoapNotesStatuses.expired48 === reportStatus?.status || SoapNotesStatuses.expiredWeek === reportStatus?.status);

	return (
		<>
			{isSessionCompletedWithoutNote && <Completed color={color} />}
			{isDraft && <Draft color={color} />}
			{isSubmitted && <Submitted color={color} />}
			{isExpired && <Expired color={color} />}
			{isPendingBT && <Pending color={color} />}
			{isUnlocked && <Unlocked color={color} />}
		</>
	);
};

export default SessionStatusIcon;
